import React, { useState } from "react";
import axios from "axios";
import { TRACKING_URL } from "../utils";

const TrackStatus = () => {
  const [trackId, setTrackId] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTrackIdChange = (e) => {
    setTrackId(e.target.value);
  };

  const handleCheckStatus = async () => {
    setLoading(true);
    setStatus(""); // Clear previous status message

    try {
      // Make the API call to get the status
      const response = await axios.get(
        `${TRACKING_URL}?id=${trackId}`
      );

      if (response?.data && response?.data?.orderDetails) {
        const { payment_status, status: orderStatus } =
          response?.data?.orderDetails;
        setStatus(
          `Your order is in ${orderStatus} State and the Payment Status is in ${payment_status}`
        );
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setStatus("Order not found");
      } else {
        setStatus("An error occurred while fetching the status.");
      }
    } finally {
      setLoading(false);
    }
  };

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "3rem",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    margin: "0rem auto",
    maxWidth: "500px",
    textAlign: "center",
  };
  const containerStyle = {
    backgroundColor: "#fdf2f2",
    maxWidth: "100%",
    minHeight: "100vh",
    padding: "10rem 0rem",
  };

  const logoStyle = {
    width: "300px",
    marginBottom: "1.5rem",
  };

  const inputStyle = {
    width: "100%",
    padding: "1rem",
    border: "1px solid #d4a256",
    borderRadius: "4px",
    marginBottom: "1rem",
    fontSize: "1rem",
  };

  const buttonStyle = {
    backgroundColor: "#d4a256",
    color: "#fff",
    padding: "1rem 2rem",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "background-color 0.3s",
  };

  const loadingStyle = {
    marginTop: "1rem",
    color: "#e94b4b",
  };

  const statusContainerStyle = {
    marginTop: "1rem",
    padding: "1rem",
    border: "1px solid #d4a256",
    borderRadius: "4px",
    backgroundColor: "#047420",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    fontSize: "1.2rem",
    color: "#fff",
  };

  const errorStatusContainerStyle = {
    marginTop: "1rem",
    padding: "1rem",
    border: "1px solid #d4a256",
    borderRadius: "4px",
    backgroundColor: "#d32408",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    fontSize: "1.2rem",
    color: "#fff",
  };

  return (
    <div style={containerStyle}>
      <div style={pageStyle}>
        <img src="/logo.png" alt="Logo" style={logoStyle} />
        <h2 style={{ marginBottom: "1.5rem", color: "#e94b4b" }}>
          Track Your Order
        </h2>
        <input
          type="text"
          value={trackId}
          onChange={handleTrackIdChange}
          placeholder="Enter your track ID"
          style={inputStyle}
        />
        <button style={buttonStyle} onClick={handleCheckStatus}>
          Check Status
        </button>
        {loading && <div style={loadingStyle}>Checking status...</div>}
        {status && (
          <div
            style={
              [
                "Order not found",
                "An error occurred while fetching the status.",
              ].includes(status)
                ? errorStatusContainerStyle
                : statusContainerStyle
            }
          >
            {status}
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackStatus;
